/** @jsx jsx */

import { useConstructor } from '@atlaskit/editor-common/hooks';
import { measureTTI, startMeasure } from '@atlaskit/editor-common/utils';
import measurements from '../../utils/performance/measure-enum';
import editorMeasureTTICallback from '../utils/editorMeasureTTICallback';

/**
 *
 * Hook to be used for running analytics on mounting the editor.
 * Should run once.
 * WARNING: Consider any changes to also make to `src/editor.tsx`
 *
 * @param performanceTracking
 * @param featureFlags
 * @param getExperienceStore function to retrieve the Editor's current ExperienceStore
 * @param createAnalyticsEvent
 */
export default function useEditorConstructor(performanceTracking, featureFlags, getExperienceStore, createAnalyticsEvent) {
  useConstructor(function () {
    var _performanceTracking$;
    startMeasure(measurements.EDITOR_MOUNTED);
    if (performanceTracking !== null && performanceTracking !== void 0 && (_performanceTracking$ = performanceTracking.ttiTracking) !== null && _performanceTracking$ !== void 0 && _performanceTracking$.enabled || featureFlags !== null && featureFlags !== void 0 && featureFlags.ufo) {
      var _performanceTracking$2, _performanceTracking$3;
      measureTTI(function (tti, ttiFromInvocation, canceled, distortedDuration) {
        editorMeasureTTICallback(tti, ttiFromInvocation, canceled, distortedDuration, performanceTracking, featureFlags, createAnalyticsEvent, getExperienceStore());
      }, performanceTracking === null || performanceTracking === void 0 || (_performanceTracking$2 = performanceTracking.ttiTracking) === null || _performanceTracking$2 === void 0 ? void 0 : _performanceTracking$2.ttiIdleThreshold, performanceTracking === null || performanceTracking === void 0 || (_performanceTracking$3 = performanceTracking.ttiTracking) === null || _performanceTracking$3 === void 0 ? void 0 : _performanceTracking$3.ttiCancelTimeout);
    }
  });
}